// Import all set data files
import base1 from './base1.json';
import base2 from './base2.json';
import base3 from './base3.json';
import base4 from './base4.json';
import base5 from './base5.json';
import base6 from './base6.json';
import basep from './basep.json';
import gym1 from './gym1.json';
import gym2 from './gym2.json';
import neo1 from './neo1.json';
import neo2 from './neo2.json';
import neo3 from './neo3.json';
import neo4 from './neo4.json';
import ecard1 from './ecard1.json';
import ecard2 from './ecard2.json';
import ecard3 from './ecard3.json';
import ex1 from './ex1.json';
import ex2 from './ex2.json';
import ex3 from './ex3.json';
import ex4 from './ex4.json';
import ex5 from './ex5.json';
import ex6 from './ex6.json';
import ex7 from './ex7.json';
import ex8 from './ex8.json';
import ex9 from './ex9.json';
import ex10 from './ex10.json';
import ex11 from './ex11.json';
import ex12 from './ex12.json';
import ex13 from './ex13.json';
import ex14 from './ex14.json';
import ex15 from './ex15.json';
import ex16 from './ex16.json';
import dp1 from './dp1.json';
import dp2 from './dp2.json';
import dp3 from './dp3.json';
import dp4 from './dp4.json';
import dp5 from './dp5.json';
import dp6 from './dp6.json';
import dp7 from './dp7.json';
import pl1 from './pl1.json';
import pl2 from './pl2.json';
import pl3 from './pl3.json';
import pl4 from './pl4.json';
import hgss1 from './hgss1.json';
import hgss2 from './hgss2.json';
import hgss3 from './hgss3.json';
import hgss4 from './hgss4.json';
import col1 from './col1.json';
import bw1 from './bw1.json';
import bw2 from './bw2.json';
import bw3 from './bw3.json';
import bw4 from './bw4.json';
import bw5 from './bw5.json';
import bw6 from './bw6.json';
import dv1 from './dv1.json';
import bw7 from './bw7.json';
import bw8 from './bw8.json';
import bw9 from './bw9.json';
import bw10 from './bw10.json';
import bw11 from './bw11.json';
import xy1 from './xy1.json';
import xy2 from './xy2.json';
import xy3 from './xy3.json';
import xy4 from './xy4.json';
import xy5 from './xy5.json';
import dc1 from './dc1.json';
import xy6 from './xy6.json';
import xy7 from './xy7.json';
import xy8 from './xy8.json';
import xy9 from './xy9.json';
import g1 from './g1.json';
import xy10 from './xy10.json';
import xy11 from './xy11.json';
import xy12 from './xy12.json';
import sm1 from './sm1.json';
import sm2 from './sm2.json';
import sm3 from './sm3.json';
import sm35 from './sm35.json';
import sm4 from './sm4.json';
import sm5 from './sm5.json';
import sm6 from './sm6.json';
import sm7 from './sm7.json';
import sm75 from './sm75.json';
import sm8 from './sm8.json';
import sm9 from './sm9.json';
import sm10 from './sm10.json';
import sm11 from './sm11.json';
import sm115 from './sm115.json';
import sma from './sma.json';
import sm12 from './sm12.json';
import swsh1 from './swsh1.json';
import swsh2 from './swsh2.json';
import swsh3 from './swsh3.json';
import swsh35 from './swsh35.json';
import swsh4 from './swsh4.json';
import swsh45 from './swsh45.json';
import swsh45sv from './swsh45sv.json';
import swsh5 from './swsh5.json';
import swsh6 from './swsh6.json';
import swsh7 from './swsh7.json';
import cel25 from './cel25.json';
import cel25c from './cel25c.json';
import swsh8 from './swsh8.json';
import swsh9 from './swsh9.json';
import swsh9tg from './swsh9tg.json';
import swsh10 from './swsh10.json';
import pgo from './pgo.json';
import swsh11 from './swsh11.json';
import swsh11tg from './swsh11tg.json';
import swsh12 from './swsh12.json';
import swsh12tg from './swsh12tg.json';
import swsh12pt5 from './swsh12pt5.json';
import swsh12pt5gg from './swsh12pt5gg.json';
import sv1 from './sv1.json';
import sv2 from './sv2.json';
import sv3 from './sv3.json';
import sv3pt5 from './sv3pt5.json';
import sv4 from './sv4.json';
import sv4pt5 from './sv4pt5.json';
import sv5 from './sv5.json';
import sv6 from './sv6.json';
import sv6pt5 from './sv6pt5.json';
import sv7 from './sv7.json';
import sv8 from './sv8.json';
import sv8pt5 from './sv8pt5.json';
import sv9 from './sv9.json';
import sv10 from './sv10.json';

// Create a map of set IDs to their data
export const setsData = {
  base1,
  base2,
  base3,
  base4,
  base5,
  base6,
  basep,
  gym1,
  gym2,
  neo1,
  neo2,
  neo3,
  neo4,
  ecard1,
  ecard2,
  ecard3,
  ex1,
  ex2,
  ex3,
  ex4,
  ex5,
  ex6,
  ex7,
  ex8,
  ex9,
  ex10,
  ex11,
  ex12,
  ex13,
  ex14,
  ex15,
  ex16,
  dp1,
  dp2,
  dp3,
  dp4,
  dp5,
  dp6,
  dp7,
  pl1,
  pl2,
  pl3,
  pl4,
  hgss1,
  hgss2,
  hgss3,
  hgss4,
  col1,
  bw1,
  bw2,
  bw3,
  bw4,
  bw5,
  bw6,
  dv1,
  bw7,
  bw8,
  bw9,
  bw10,
  bw11,
  xy1,
  xy2,
  xy3,
  xy4,
  xy5,
  dc1,
  xy6,
  xy7,
  xy8,
  xy9,
  g1,
  xy10,
  xy11,
  xy12,
  sm1,
  sm2,
  sm3,
  sm35,
  sm4,
  sm5,
  sm6,
  sm7,
  sm75,
  sm8,
  sm9,
  sm10,
  sm11,
  sm115,
  sma,
  sm12,
  swsh1,
  swsh2,
  swsh3,
  swsh35,
  swsh4,
  swsh45,
  swsh45sv,
  swsh5,
  swsh6,
  swsh7,
  cel25,
  cel25c,
  swsh8,
  swsh9,
  swsh9tg,
  swsh10,
  pgo,
  swsh11,
  swsh11tg,
  swsh12,
  swsh12tg,
  swsh12pt5,
  swsh12pt5gg,
  sv1,
  sv2,
  sv3,
  sv3pt5,
  sv4,
  sv4pt5,
  sv5,
  sv6,
  sv6pt5,
  sv7,
  sv8,
  sv8pt5,
  sv9,
  sv10
};

// Helper function to get cards from specified sets
export const getCardsFromSets = (setIds) => {
  const allCards = [];
  
  setIds.forEach(setId => {
    if (setsData[setId]) {
      // Add all cards from this set
      allCards.push(...setsData[setId]);
    }
  });
  
  return allCards;
};
